<div class="pt-3 pr-3 pl-3 pb-2 action-holder" *ngIf="dialogData.type == 'side'">
    <div *ngIf="!dialogData.force"></div>

    <div class="row">
        <div class="col-12">
            <div class="row p-0">
                <div class="col-12 action-title pb-2 heading-font">
                    <i class="pi pi-chart-bar action-icon mr-1"></i> {{dialogData.title}}
                </div>
                <div class="col-12 action-content" [innerHTML]="dialogData.content"></div>
            </div>
        </div>
    </div>

    <div class="row mt-2 pt-1" *ngIf="dialogData.buttons && dialogData.buttons.length > 0">
        <div class="col-12 flex justify-content-between">
            <ng-container *ngFor="let button of dialogData.buttons">
                <dd-action-needed-button [btn]="button" (onClick)="buttonClicked($event)"></dd-action-needed-button>
            </ng-container>
        </div>
    </div>

</div>

<div class="pt-3 pr-3 pl-3 pb-2 action-holder" *ngIf="dialogData.type == 'cover'">
    <div *ngIf="!dialogData.force"></div>

    <div class="row">
        <div class="col-12">
            <div class="row p-0">
                <div class="col-12 action-title pb-2 heading-font">
                    <i class="fas fa-info-circle action-icon mr-1"></i> {{dialogData.title}}
                </div>
                <div class="col-12 action-content" [innerHTML]="dialogData.content"></div>
            </div>
        </div>
    </div>

    <div class="row mt-2 pt-1" *ngIf="dialogData.buttons && dialogData.buttons.length > 0">
        <div class="col-12 flex justify-content-between">
            <ng-container *ngFor="let button of dialogData.buttons">
                <dd-action-needed-button [btn]="button" (onClick)="buttonClicked($event)"></dd-action-needed-button>
            </ng-container>
        </div>
    </div>

</div>


<div class="p-1 action-holder" *ngIf="dialogData.type == 'popup'">
    <div *ngIf="!dialogData.force"></div>

    <div style="
    height: 300px;
    background-image: url(https://www.affarskompetens.se/wp-content/uploads/hydroponics-9751205_1920.jpg) !important;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
">
        <h3 style="
    color: white;
    background: rgba(4, 60, 83, 0.56);
    text-align: center;
    width: 90%;
    padding: 20px 0;
">Hållbarhetsvecka med Affärskompetens</h3>
    </div>

    <div class="px-3 pt-3">
        <p>H&aring;llbarhet &auml;r en resa &ndash; och alla steg r&auml;knas. Ta del av f&ouml;retagares erfarenheter, f&ouml;rdjupa dina kunskaper och f&aring; inspiration till hur du kan utveckla och st&auml;rka ditt h&aring;llbarhetsarbete &auml;nnu mer.<br/></p>
        <p class="pb-0 mb-1">Vi bjuder p&aring; intervjuer, mallar och massa tips och r&aring;d, b&aring;de till dig som arbetat med h&aring;llbarhet en tid och f&ouml;r dig som ska ta f&ouml;rsta steget.&nbsp;</p>
    </div>

    <div class="row pb-3 mw-100" *ngIf="dialogData.buttons && dialogData.buttons.length > 0">
        <div class="col-12 flex justify-content-between project-{{currentProject}}">
            <ng-container *ngFor="let button of dialogData.buttons">
                <dd-action-needed-button [btn]="button" (onClick)="buttonClicked($event)"></dd-action-needed-button>
            </ng-container>
        </div>
    </div>

</div>
